import styled from "@emotion/styled"
import { Text, Title, Button } from "../../styles/common.styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
  percentage?: number
  noVote?: boolean
  isFullScreen?: boolean
  isMobile?: boolean
  isCreatedPoll?: boolean
  numberVotes?: number
}

export const PollsWrapper = styled.div`
  padding: 1rem;
`

export const PollsContainer = styled.div<StylesProps>`
  padding: 0.5rem;
  border: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder
      ? `2px solid ${roomStyles?.servicePanelElementBorder}`
      : "2px solid #ced4da"};
  border-radius: 0.6rem;
  background-color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBackground ?? "white"};
`
export const HeaderCreatePoll = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ChatPollContainer = styled(PollsContainer)<StylesProps>`
  position: relative;
  padding: 0.3rem;
  background-color: ${({ isFullScreen, roomStyles }) =>
    isFullScreen
      ? "rgba(0, 0, 0, 0.5)"
      : roomStyles?.servicePanelElementBackground ?? "white"};
`
export const UserInfoContainer = styled.div`
  display: flex;
  color: gray;
`

export const NameContainer = styled.div`
  padding-left: 0.33rem;
`
export const TimeContainer = styled.div`
  margin-left: auto;
  font-size: 0.75rem;
  color: #718096;
`

export const VariantsWrapper = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  padding-left: calc(24px + 0.33rem);
`

export const VariantsContainer = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  margin-top: 0.4rem;
  /* max-height: ${({ isMobile }) => isMobile && "100px"};
  overflow-y: ${({ isMobile }) => isMobile && "scroll"}; */
`

export const VariantsButtonsContainer = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ isMobile }) => (isMobile ? "0rem" : "0.4rem")};
  /*  max-height: ${({ isMobile }) => isMobile && "100px"};
  overflow-y: ${({ isMobile }) => isMobile && "scroll"}; */
`

export const VariantContainer = styled.div<StylesProps>`
  display: flex;
  border: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder
      ? `1px solid ${roomStyles?.servicePanelElementBorder}`
      : "1px solid #ced4da"};
  border-radius: 0.375rem;
  position: relative;
  height: 100%;
  min-height: 31.5px;
  /*  min-height: 30px; */
  width: 82%;
`

export const VariantWrapper = styled.div`
  display: flex;
  margin-bottom: 0.4rem;
`

export const CreateAnotherPollContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;
  margin-top: 0px;
`

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  /* position: relative; */
`

export const VariantButtonContainer = styled.div<StylesProps>`
  display: flex;
  width: 80%;
  border-radius: 0.3rem;
  margin-bottom: 0.4rem;
  padding: 5px;
  justify-content: center;
  cursor: pointer;
  background-color: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonBackgroundColor
      ? roomStyles?.secondaryAccessButtonBackgroundColor
      : "#1AC541"};
  border: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonBorderColor
      ? `1px solid ${
          roomStyles?.secondaryAccessButtonBorderColor
            ? roomStyles.secondaryAccessButtonBorderColor
            : "transparent"
        }`
      : "0px"};
  color: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonTextColor
      ? roomStyles.secondaryAccessButtonTextColor
      : "#FFFFFF"};
  &:hover {
    background-color: ${({ roomStyles, isMobile }) =>
      isMobile
        ? roomStyles?.secondaryAccessButtonBackgroundColor
        : roomStyles?.secondaryAccessButtonMouseoverColor
        ? roomStyles.secondaryAccessButtonMouseoverColor
        : "#24A840"};
    color: ${({ roomStyles, isMobile }) =>
      isMobile
        ? roomStyles?.secondaryAccessButtonTextColor
        : roomStyles?.secondaryAccessButtonTextMouseoverColor
        ? roomStyles.secondaryAccessButtonTextMouseoverColor
        : "#FFFFFF"};
  }
`

export const FormsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ChoicesWrapper = styled.div`
  display: flex;
  margin-top: 0.4rem;
`
export const ChoicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ChoiceContainer = styled.div`
  margin-bottom: 0.4rem;
`

export const AddButtonContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 0.4rem;
  margin-left: 0.5rem;
`

export const PollsSubTitle = styled(Title)`
  font-size: 12px;
  margin-bottom: 5px;
  text-transform: uppercase;
  font-weight: 700;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementSecondaryText ?? "rgba(0, 0, 0, 0.6)"};
`

export const CreateAnotherPoll = styled(PollsSubTitle)`
  text-transform: none;
  margin-bottom: 0;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  color: ${({ roomStyles }) => roomStyles?.servicePanelColorLabels ?? "#000"};
  &::first-letter {
    font-size: 12px;
  }
`

export const VariantButtonText = styled.p<StylesProps>`
  z-index: 1000;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-decoration: unset;
  cursor: unset;
  font-size: 13px;
  font-weight: 500;
  /* color: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonTextColor
      ? roomStyles?.secondaryAccessButtonTextColor
      : "#FFFFFF"};
  &:hover {
    color: ${({ roomStyles, isMobile }) =>
    isMobile
      ? roomStyles?.secondaryAccessButtonTextColor
      : roomStyles?.accessButtonTextMouseoverColor
      ? roomStyles?.accessButtonTextMouseoverColor
      : "#FFFFFF"};
  } */
`

export const PercentageContainer = styled.div<StylesProps>`
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: right;
  margin-left: ${({ isCreatedPoll }) => (isCreatedPoll ? "auto" : "0.5rem")};
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText &&
    roomStyles?.servicePanelElementPrimaryText};
  width: 15%;
`
export const PercentageVariantContainer = styled(
  PercentageContainer
)<StylesProps>`
  margin-left: 10px;
  width: 18%;
  font-size: 15px;
  color: ${({ isFullScreen, roomStyles }) =>
    isFullScreen ? "white" : roomStyles?.servicePanelElementPrimaryText};
`

export const VariantDataContainer = styled.div<StylesProps>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-radius: ${({ isFullScreen, roomStyles }) =>
    isFullScreen ? "0.275rem" : "0.375rem"};
  background: ${({ isFullScreen, roomStyles }) => isFullScreen && "white"};
`

export const VariantText = styled.p<StylesProps>`
  font-size: 0.875rem;
  z-index: 1000;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: unset;
  text-decoration: unset;
  cursor: unset;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  line-height: 1.75;
  color: ${({ roomStyles, isFullScreen, numberVotes }) =>
    isFullScreen && numberVotes > 0
      ? "black"
      : isFullScreen && numberVotes === 0
      ? "black"
      : roomStyles.servicePanelElementPrimaryText ?? "#495057"};
`

export const VariantTextMod = styled.p<StylesProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 1rem;
  line-height: 2.2;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  color: ${({ roomStyles }) =>
    roomStyles.servicePanelElementPrimaryText ?? "#495057"};
  z-index: 100;
`

export const Scale = styled.div<StylesProps>`
  display: flex;
  position: absolute;
  background-image: ${({ isFullScreen, roomStyles }) =>
    `linear-gradient(${roomStyles?.servicePanelElementBorder}, ${roomStyles?.servicePanelElementBackground})`};
  border-radius: 0.3rem;
  border-top-right-radius: ${({ percentage }) =>
    percentage !== 100 ? "0rem" : "0.3rem"};
  border-bottom-right-radius: ${({ percentage }) =>
    percentage !== 100 ? "0rem" : "0.3rem"};
  height: 100%;
  width: ${({ percentage }) => `${percentage}%`};
`

export const ScaleMod = styled(Scale)`
  border-radius: 0.3rem;
  height: 36px;
  border-top-right-radius: ${({ percentage }) =>
    percentage !== 100 ? "0rem" : "0.3rem"};
  border-bottom-right-radius: ${({ percentage }) =>
    percentage !== 100 ? "0rem" : "0.3rem"};
  margin-right: 10px;
`

export const PollsTextTip = styled(Text)`
  color: #495057;
  opacity: 1;
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 0.6rem;
`

export const PollTextTip = styled(PollsTextTip)<StylesProps>`
  padding-left: calc(24px + 0.33rem);
  margin-bottom: 0px;
  color: ${({ isFullScreen, roomStyles }) =>
    isFullScreen ? "white" : roomStyles?.servicePanelElementLabels};
`

export const PollTextTipCounter = styled(PollsTextTip)<StylesProps>`
  color: ${({ isFullScreen, roomStyles }) =>
    isFullScreen ? "white" : roomStyles?.servicePanelElementLabels};
  opacity: ${({ isFullScreen }) => isFullScreen && "1"};
  padding-left: 0px;
  margin-bottom: 0px;
  text-align: right;
`

export const ChatPollTitle = styled(PollTextTip)<StylesProps>`
  color: ${({ isFullScreen, roomStyles }) =>
    isFullScreen
      ? "white"
      : roomStyles?.servicePanelElementPrimaryText ?? "#000000"};

  fontSize: 0.875rem;
  opacity: 1;
`

export const CreatePollCounter = styled(PollTextTip)`
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementLabels ?? "#000000"};
  padding-left: 0px;
  margin-bottom: 0.4rem;
  margin-left: auto;
`

export const ShowPollButton = styled(Button)`
  margin-bottom: 0.4rem;
  background-color: ${({ roomStyles }) =>
    roomStyles?.accessButtonBackgroundColor
      ? roomStyles?.accessButtonBackgroundColor
      : "#1AC541"};
  border: ${({ roomStyles }) =>
    roomStyles?.accessButtonBorderColor
      ? `1px solid ${
          roomStyles?.accessButtonBorderColor
            ? roomStyles.accessButtonBorderColor
            : "transparent"
        }`
      : "0px"};
  color: ${({ roomStyles }) =>
    roomStyles?.accessButtonTextColor
      ? roomStyles?.accessButtonTextColor
      : "#FFFFFF"};
  &:hover {
    background-color: ${({ roomStyles }) =>
      roomStyles?.accessButtonMouseoverColor
        ? roomStyles.accessButtonMouseoverColor
        : "#24A840"};
    color: ${({ roomStyles }) =>
      roomStyles?.accessButtonTextMouseoverColor
        ? roomStyles.accessButtonTextMouseoverColor
        : "#FFFFFF"};
  }
  &:disabled {
    opacity: 0.25;
  }
`
export const DeletePollButton = styled(Button)`
  background-color: ${({ roomStyles }) =>
    roomStyles?.closeButtonBackgroundColor
      ? roomStyles.closeButtonBackgroundColor
      : "#FF0000"};
  border: ${({ roomStyles }) =>
    roomStyles?.closeButtonBorderColor
      ? `1px solid ${
          roomStyles?.closeButtonBorderColor
            ? roomStyles.closeButtonBorderColor
            : "transparent"
        }`
      : "0px"};
  color: ${({ roomStyles }) =>
    roomStyles?.joinPageButtonTextColor
      ? roomStyles?.joinPageButtonTextColor
      : "#FFFFFF"};
  &:hover {
    background-color: ${({ roomStyles }) =>
      roomStyles?.closeButtonMouseoverBackgroundColor
        ? roomStyles.closeButtonMouseoverBackgroundColor
        : "#E1262A"};
    color: ${({ roomStyles }) =>
      roomStyles.joinPageButtonMouseoverTextColor
        ? roomStyles.joinPageButtonMouseoverTextColor
        : "#FFFFFF"};
  }
  &:disabled {
    opacity: 0.25;
  }
`

export const AddButton = styled(Button)`
  height: 38px;
  &:disabled {
    opacity: 0.25;
  }
`
